import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import {IIssueLogFormProps} from './AddNewDataPointForm.types';

export const IssueLogForm: React.FC<IIssueLogFormProps> = ({
  issueDate,
  issueType,
  pestsAndDiseasesId,
  pestDiseaseOptions,
  pestDiseaseOptionsLoading,
  pestDiseaseOptionsError,
  severityScale,
  controlMeasures,
  preventativeMeasures,
  duringHarvest,
  onIssueDateChange,
  onIssueTypeChange,
  onPestsAndDiseasesIdChange,
  onSeverityScaleChange,
  onControlMeasuresChange,
  onPreventativeMeasuresChange,
  onDuringHarvestChange,
}) => {
  return (
    <>
      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Issue Date
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="date"
          value={issueDate}
          onChange={(e) => onIssueDateChange(e.target.value)}
          InputLabelProps={{shrink: true}}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Issue Type
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Describe the type of issue"
          value={issueType}
          onChange={(e) => onIssueTypeChange(e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Pest / Disease
        </Typography>
        <Box>
          <TextField
            select
            fullWidth
            disabled={!!pestDiseaseOptionsLoading}
            variant="outlined"
            size="small"
            value={pestsAndDiseasesId}
            onChange={(e) => onPestsAndDiseasesIdChange(e.target.value)}
            InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
          >
            <MenuItem value="">
              <em>
                {pestDiseaseOptionsLoading
                  ? 'Loading pest/disease...'
                  : 'Select pest or disease'}
              </em>
            </MenuItem>
            {pestDiseaseOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>

          {pestDiseaseOptionsLoading ? (
            <Box mt={1} display="flex" alignItems="center" style={{gap: 8}}>
              <CircularProgress size={18} />
              <Typography variant="caption" style={{color: '#5A6B68'}}>
                Loading options...
              </Typography>
            </Box>
          ) : pestDiseaseOptionsError ? (
            <Typography
              variant="caption"
              style={{color: '#972830', display: 'block', marginTop: 6}}
            >
              {pestDiseaseOptionsError}
            </Typography>
          ) : !pestDiseaseOptions.length ? (
            <Typography
              variant="caption"
              style={{color: '#5A6B68', display: 'block', marginTop: 6}}
            >
              No pest/disease options found.
            </Typography>
          ) : null}
        </Box>
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Severity Scale
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter severity (e.g. 1–5)"
          value={severityScale}
          onChange={(e) => onSeverityScaleChange(e.target.value)}
          inputProps={{min: 0, step: 1}}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Control Measures Applied
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          size="small"
          placeholder="Describe any control measures taken"
          value={controlMeasures}
          onChange={(e) => onControlMeasuresChange(e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Preventative Measures Taken
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          size="small"
          placeholder="Describe preventative measures"
          value={preventativeMeasures}
          onChange={(e) => onPreventativeMeasuresChange(e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={duringHarvest}
              onChange={(e) => onDuringHarvestChange(e.target.checked)}
            />
          }
          label="Issue occurred during harvest"
        />
      </Box>
    </>
  );
};
